import { render, staticRenderFns } from "./CheeseTreatmentItems.vue?vue&type=template&id=037568f3&scoped=true"
import script from "./CheeseTreatmentItems.vue?vue&type=script&lang=ts"
export * from "./CheeseTreatmentItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037568f3",
  null
  
)

export default component.exports